import { defineComponent, ref, computed } from 'vue'

import PointPage from '@/organizations/_default/point'
import PointSearchConditions from '@/components/common/PointSearchConditions.vue'
import ProductModal from '@/organizations/livedo/default/components/ProductModal.vue'
import FilterInfo from '@/organizations/livedo/default/components/FilterInfo.vue'

import { Filters } from '@/services/Filters.ts'

export default defineComponent({
  extends: PointPage,
  components: {
    PointSearchConditions,
    ProductModal,
    FilterInfo
  },
  setup(props, context) {
    const page = PointPage.setup(props, context)

    // 選択した商品とその他の商品を分割するために利用
    const searchConditionsState = ref({
      isSelected: false,
      selectedIds: [],
      notSelectedIds: []
    })

    if (sessionStorage) {
      const cache = Filters.cache.load()
      const filterIds = cache?.search_conditions || []

      // 選択した商品とその他の商品を分割
      if (filterIds && filterIds.length > 0) {
        const ids = Filters.getPointFilters(
          Filters.TYPE_SEARCH_CONDITIONS,
          page.point.value,
          Filters.getFilterTree(Filters.TYPE_SEARCH_CONDITIONS)
        ).filter(c => c.is_show).map(c => c.id)

        if (ids.length > 0) {
          searchConditionsState.value.isSelected = true
          ids.forEach((id) => {
            if (filterIds.includes(id)) {
              searchConditionsState.value.selectedIds.push(id)
            } else {
              searchConditionsState.value.notSelectedIds.push(id)
            }
          })
        }
      }
    }

    /**
     * クリックしたフィルターを保持
     *
     * 商品モーダルに以下のプロパティを使用
     * filter.name: 商品名(既存)
     * filter.image.url: 商品画像のURL(既存)
     * filter.extra_fields.product_description: 商品説明(追加)
     * filter.extra_fields.product_url: 商品詳細ページのURL(追加)
     * NOTE: 商品詳細ページのURLは既存のfilter.urlを使用しない
     *       このプロパティにURLを格納すると、店舗ページのフィルターがリンクとして機能してしまうため、モーダル用に新たなプロパティに保持
     */
    const selectedProduct = ref({})
    const modalRef = ref(null)

    const onClickedSearchCondition = (searchCondition) => {
      // キャンペーン実施店（cp_系）の場合は商品モーダルを開かない
      if (searchCondition.id.startsWith('cp_')) {
        return
      }
      
      selectedProduct.value = searchCondition
      modalRef.value.open()
    }

    // タイトル表示の条件を判定
    const hasCpStoreInSelected = computed(() => {
      if (sessionStorage) {
        const cache = Filters.cache.load()
        const filterIds = cache?.search_conditions || []
        return filterIds.some(id => id.startsWith('cp_'))
      }
      return false
    })

    const hasCpStoreInNotSelected = computed(() => {
      return searchConditionsState.value.notSelectedIds.some(id => id.startsWith('cp_'))
    })

    return {
      ...page,
      selectedProduct,
      modalRef,
      searchConditionsState,
      onClickedSearchCondition,
      hasCpStoreInSelected,
      hasCpStoreInNotSelected
    }
  }
})
